<template>
  <div class="casesPage">
    <head-top></head-top>
    <div class="banner">
      <h3>软件模板</h3>
      <p>商鼎云持续在电商领域深耕</p>
    </div>
    <div class="casesNav">
      <ul>
        <li :class="{'current':type == 1000}" @click="type = 1000;getFilter()">全部</li>
        <li :class="{'current':type == 1201}" @click="type = 1201;getFilter()">电商模板</li>
        <li :class="{'current':type == 1301}" @click="type = 1301;getFilter()">客户案例</li>
      </ul>
    </div>
    <div class="casesListBox">
      <div class="casesList" v-for="(item,index) of casesList" :key="index" @click="openJump('/templateDetails/'+item.index);">
        <div class="casesImg">
          <img :src="item.coverImg">
        </div>
        <div class="content">
          <h3>{{item.title}}</h3>
          <div class="types">
            <span>使用类型：</span>
            <span v-if="item.type == 1101">模板定制</span>
            <span v-if="item.type == 1201">客户案例</span>
          </div>
          <div class="price">
            <span>￥{{item.price}}</span>
            <span>{{item.buyNum}}人购买</span>
          </div>
        </div>
      </div>
    </div>
    <foot-guide></foot-guide>
  </div>
</template>
<script>
export default {
  data() {
    return {
      casesList: [],
      // 公众号 1201 小程序 1301
      swiperOption: {
        autoplay: 3200,
        setWrapperSize: true,
        observeParents: true,
        loop: true,
        speed: 1000,
        //设置分页
        pagination: ".swiper-pagination",
        //设置分页点击
        paginationClickable: true,
        //设置上一页，下一页
        prevButton: ".swiper-button-prev",
        nextButton: ".swiper-button-next",
        autoplayDisableOnInteraction: false
      },
      type: 1000
    };
  },
  created() {
    templateDtata.forEach((item, index) => {
      item.index = index;
    });
    this.casesList = templateDtata;
  },
  methods: {
    getFilter() {
      var casesList = new Array();
      if (this.type == 1000) {
        this.casesList = templateDtata;
      } else {
        templateDtata.forEach(item => {
          if (this.type == item.type) {
            casesList.push(item);
          }
        });
        this.casesList = casesList;
        console.log(casesList);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import "src/style/mixin";
.casesPage {
}
.banner {
  background-image: url("https://qn.kemean.cn/upload/201809/07/3d4059a57c2d4b26bcbb015e90e4686d");
}
@media screen and (min-width: 1200px) {
  .casesNav {
    display: flex;
    justify-content: center;
    border-bottom: 1px solid #dddddd;
    background-color: #fff;
    ul {
      display: flex;
      li {
        height: 80px;
        line-height: 80px;
        border-bottom: 3px solid #fff;
        font-size: 18px;
        color: #666666;
        margin-left: 40px;
        padding: 0px 11px;
        cursor: pointer;
        &:first-child {
          margin-left: 0;
        }
        &.current {
          border-bottom: 3px solid $mainColor;
          color: $mainColor;
        }
      }
    }
  }
  .casesListBox {
    display: flex;
    flex-wrap: wrap;
    padding: 60px 0;
    max-width: 1200px;
    margin: 0 auto;
    .casesList {
      width: 24%;
      margin-bottom: 20px;
      cursor: pointer;
      background-color: #fff;
      box-shadow: 0 0 10px 0 #999;
      border-radius: 6px;
      overflow: hidden;
      margin: 8px 0.5%;
      .casesImg {
        width: 100%;
        height: 300px;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
          transition: all 0.6s;
        }
      }

      &:hover {
        img {
          transform: scale(1.3, 1.3);
        }
        // &::before {
        //   background-color: rgba(0, 0, 0, 0.3);
        // }
      }
      > .content {
        padding: 10px 10px;
        h3 {
          font-size: 18px;
          color: #000;
          font-weight: bold;
        }
        > .types {
          display: flex;
          justify-content: space-between;
          margin-top: 10px;
          padding-bottom: 8px;
          span {
            color: #666;
            font-size: 14px;
          }
        }
        > .price {
          display: flex;
          justify-content: space-between;
          border-top: 1px solid #eee;
          padding-top: 5px;
          span:nth-child(1) {
            color: red;
            font-size: 18px;
          }
          span:nth-child(2) {
            color: #666;
            font-size: 14px;
          }
        }
      }
    }
  }
  .partnerBox {
    background-color: #fff;
    > div {
      max-width: 1200px;
      width: 100%;
      margin: 0 auto;
      padding: 39px 0 9px 0;
    }
    ul {
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      li {
        width: 300px;
        height: 100px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 50px;
        img {
          max-width: 100%;
          max-height: 100%;
        }
      }
    }
  }
  .partnerSaid {
    background-color: #f4f4f4;
    padding: 80px 0;
    .partner-scroll {
      padding-bottom: 40px;
      .swiper-slide {
        display: flex;
        align-items: center;
        flex-direction: column;
        i {
          color: #333333;
          font-size: 60px;
        }
        p {
          font-size: 24px;
          color: #333333;
          text-align: center;
          max-width: 1097px;
          margin-top: 10px;
        }
        span {
          font-size: 30px;
          color: #333333;
          margin-top: 20px;
          font-weight: bold;
        }
      }
    }
  }
}
@media screen and (min-width: 750px) and (max-width: 1200px) {
  .casesNav {
    display: flex;
    justify-content: center;
    border-bottom: 1px solid #dddddd;
    background-color: #fff;
    ul {
      display: flex;
      li {
        height: 80px;
        line-height: 80px;
        border-bottom: 3px solid #fff;
        font-size: 18px;
        color: #666666;
        margin-left: 40px;
        padding: 0px 11px;
        cursor: pointer;
        &:first-child {
          margin-left: 0;
        }
        &.current {
          border-bottom: 3px solid $mainColor;
          color: $mainColor;
        }
      }
    }
  }
  .casesListBox {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    padding: 40px 0;
    margin: 0 auto;
    .casesList {
      width: 280px;
      cursor: pointer;
      background-color: #fff;
      box-shadow: 0 0 10px 0 #999;
      border-radius: 6px;
      overflow: hidden;
      margin: 0 20px 20px 20px;
      .casesImg {
        width: 100%;
        height: 300px;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
          transition: all 0.6s;
        }
      }

      &:hover {
        img {
          transform: scale(1.3, 1.3);
        }
        // &::before {
        //   background-color: rgba(0, 0, 0, 0.3);
        // }
      }
      > .content {
        padding: 10px 10px;
        h3 {
          font-size: 18px;
          color: #000;
          font-weight: bold;
        }
        > .types {
          display: flex;
          justify-content: space-between;
          margin-top: 10px;
          padding-bottom: 8px;
          span {
            color: #666;
            font-size: 14px;
          }
        }
        > .price {
          display: flex;
          justify-content: space-between;
          border-top: 1px solid #eee;
          padding-top: 5px;
          span:nth-child(1) {
            color: red;
            font-size: 18px;
          }
          span:nth-child(2) {
            color: #666;
            font-size: 14px;
          }
        }
      }
    }
  }
  .partnerBox {
    background-color: #fff;
    > div {
      max-width: 1200px;
      width: 100%;
      margin: 0 auto;
      padding: 39px 0 9px 0;
    }
    ul {
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      li {
        width: 300px;
        height: 100px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 50px;
        img {
          max-width: 100%;
          max-height: 100%;
        }
      }
    }
  }
  .partnerSaid {
    background-color: #f4f4f4;
    padding: 80px 0;
    .partner-scroll {
      padding-bottom: 40px;
      .swiper-slide {
        display: flex;
        align-items: center;
        flex-direction: column;
        i {
          color: #333333;
          font-size: 60px;
        }
        p {
          font-size: 24px;
          color: #333333;
          text-align: center;
          max-width: 1097px;
          margin-top: 10px;
        }
        span {
          font-size: 30px;
          color: #333333;
          margin-top: 20px;
          font-weight: bold;
        }
      }
    }
  }
}
@media screen and (max-width: 750px) {
  .casesNav {
    display: flex;
    justify-content: center;
    border-bottom: 1px solid #dddddd;
    background-color: #fff;
    ul {
      display: flex;
      li {
        height: 12vw;
        line-height: 12vw;
        border-bottom: 3px solid #fff;
        font-size: 4.2vw;
        color: #666666;
        margin-left: 7vw;
        padding: 0px 2vw;
        cursor: pointer;
        &:first-child {
          margin-left: 0;
        }
        &.current {
          border-bottom: 3px solid $mainColor;
          color: $mainColor;
        }
      }
    }
  }
  .casesListBox {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 6vw 0vw;
    max-width: 1200px;
    margin: 0 auto;
    .casesList {
      width: 49%;
      margin-bottom: 2vw;
      cursor: pointer;
      background-color: #fff;
      box-shadow: 0 0 2vw 0 #999;
      border-radius: 0.6vw;
      overflow: hidden;
      .casesImg {
        width: 100%;
        height: 48vw;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
          transition: all 0.6s;
        }
      }

      &:hover {
        img {
          transform: scale(1.3, 1.3);
        }
        // &::before {
        //   background-color: rgba(0, 0, 0, 0.3);
        // }
      }
      > .content {
        padding: 2vw 1vw;
        h3 {
          font-size: 4.2vw;
          color: #000;
          font-weight: bold;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        > .types {
          display: flex;
          justify-content: space-between;
          margin-top: 2vw;
          padding-bottom: 1.6vw;
          span {
            color: #666;
            font-size: 3.8vw;
          }
        }
        > .price {
          display: flex;
          justify-content: space-between;
          border-top: 1px solid #eee;
          padding-top: 5px;
          span:nth-child(1) {
            color: red;
            font-size: 4vw;
          }
          span:nth-child(2) {
            color: #666;
            font-size: 3.6vw;
          }
        }
      }
    }
  }
  .partnerBox {
    width: 100%;
    padding: 4vw 2vw 1vw 2vw;
    ul {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      li {
        width: 49%;
        height: 22vw;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 5vw;
        img {
          max-width: 100%;
          max-height: 100%;
        }
      }
    }
  }
  .partnerSaid {
    background-color: #f4f4f4;
    padding: 8vw 0;
    .partner-scroll {
      padding-bottom: 40px;
      .swiper-slide {
        display: flex;
        align-items: center;
        flex-direction: column;
        i {
          color: #333333;
          font-size: 8vw;
        }
        p {
          font-size: 3.6vw;
          color: #333333;
          text-align: center;
          padding: 0px 2vw;
          margin-top: 1vw;
        }
        span {
          font-size: 3.6vw;
          color: #333333;
          margin-top: 2vw;
          font-weight: bold;
        }
      }
    }
  }
}
</style>
